/**
 * Mortgage PRE+ Tagular Tracking
 */

import tagularModule from 'js/store/helpers/tagular'

;(function() {
  if (typeof tagular !== 'function') {
    return
  }

  var preElement = document.getElementById('pre-display');
  var afterPreElement = document.getElementById('after-pre-display');

  var correlationId = tagularModule.generateUniqueId()

  var eventList = [
    {
      selector: '[data-tracking-id="v1-mortgage-type-select"]', // pre-v1 loan type dropdown
      type: 'change',
      handler: loanTypeInputted
    },
    {
      selector: '[data-tracking-id="v2-mortgage-type-select"]', // pre-v2 loan type dropdown
      type: 'change',
      handler: function (event) {
        loanTypeInputted(event, {
          formName: 'PREV2',
          formType: 'PREV2',
        })
      }
    },
    {
      selector: '#pre-zipcode [data-tracking-id="zip-code"]', // zip code input - desktop
      type: 'keydown',
      handler: zipcodeInputted
    },
    {
      selector: '#pre-zipcode-mobile [data-tracking-id="zip-code"]', // zip code input - mobile
      type: 'keydown',
      handler: zipcodeInputted
    },

    {
      selector: '#pre-zipcode form', // zip code next button - desktop
      type: 'submit',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          text: 'next',
          name: 'Zipcode',
          position: 'top',
          elementType: 'button'
        })
        addClass(preElement, '+display-none')
        removeClass(afterPreElement, '+display-none')
        window.initialDimensions.zipCode = document.querySelector('#pre-zipcode [data-tracking-id="zip-code"]').value
        loadMRTCode()
      }
    },
    {
      selector: '#pre-zipcode-mobile form', // zip code next button - mobile
      type: 'submit',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          text: 'next',
          name: 'Zipcode',
          position: 'bottom',
          elementType: 'button'
        })
        addClass(preElement, '+display-none')
        removeClass(afterPreElement, '+display-none')
        window.initialDimensions.zipCode = document.querySelector('#pre-zipcode-mobile [data-tracking-id="zip-code"]').value
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v2-skip-and-show-rates"]', // pre-v2 skip and show rates
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'Show me rates',
          position: 'top',
          text: 'Show me rates',
          location: 'PREV2',
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-skip-and-show-rates"], [data-tracking-id="v2-sticky-skip-and-show-rates"]', // pre-v2 skip and show rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Show me rates',
          text: 'Show me rates',
          position: 'top',
          location: 'PREV2'
        })
        addClass(preElement, '+display-none')
        removeClass(afterPreElement, '+display-none')
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-skip-and-show-rates"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Skip',
          position: 'top',
          elementType: 'link'
        })
        addClass(preElement, '+display-none')
        removeClass(afterPreElement, '+display-none')
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-1"]', // spotlight rate card - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Left',
          elementType: 'card'
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-rate-card-apr-1"]', // pre-v2 spotlight rate card - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Left',
          elementType: 'card',
          location: 'PREV2'
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-rate-card-apr-1"]', // pre-v2 lowest offers
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Lowest Offers',
          position: 'middle',
          text: 'Bankrate\'s lowest offers',
          location: 'PREV2',
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-2', // spotlight rate card - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Right',
          elementType: 'card'
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-rate-card-apr-2', // pre-v2 spotlight rate card - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Right',
          elementType: 'card',
          location: 'PREV2'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-cta-1"]', // spotlight rate card CTA - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates left'
        })
        rateCardClickHandler('rate-card-title-1');
      }
    },
    {
      selector: '[data-tracking-id="v2-rate-card-cta-1"]', // pre-v2 spotlight rate card CTA - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates left',
          location: 'PREV2',
        })
        rateCardClickHandler('rate-card-title-1');
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-cta-2"]', // spotlight rate card CTA - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates right'
        })
        rateCardClickHandler('rate-card-title-2');
      }
    },
    {
      selector: '[data-tracking-id="v2-rate-card-cta-2"]', // pre-v2 spotlight rate card CTA - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates right',
          location: 'PREV2',
        })
        rateCardClickHandler('rate-card-title-2');
      }
    },
    {
      selector: '[data-tracking-id="v1-wp-content-cta"]', // cta below WP content
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Get matched with a lender',
          position: 'bottom'
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-wp-content-cta"]', // pre-v2 cta below WP content
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Get matched with a lender',
          position: 'bottom',
          location: 'PREV2',
        })
      }
    },
    {
      selector: '#pre-loantype [data-tracking-id="pre-cta-purchase"]', // select loan type cta - purchase - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '#pre-loantype-mobile [data-tracking-id="pre-cta-purchase"]', // select loan type cta - purchase - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'bottom'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '#pre-loantype [data-tracking-id="pre-cta-refinance"]', // select loan type cta - Refinance - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '#pre-loantype-mobile [data-tracking-id="pre-cta-refinance"]', // select loan type cta - Refinance - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'bottom'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '#pre-qn-loantype', // select loantype question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'PurchaseRefi',
          position: 'top'
        })
      }
    },
    {
      selector: '#pre-zipcode', // input zipcode question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'Zipcode',
          position: 'top',
          text: 'Enter your ZIP code for personalized rates'
        })
      }
    },
    {
      selector: '#pre-zipcode-mobile', // input zipcode question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'Zipcode',
          position: 'bottom',
          text: 'Enter your ZIP code for personalized rates'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-1"]', // rate cards
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Lowest Offers',
          position: 'middle',
          text: "Bankrate's lowest offers"
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-wp-content-cta"]', // cta below WP content
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Get matched with a lender',
          position: 'bottom'
        })
      }
    },
    {
      selector: '[data-tracking-id="v2-wp-content-cta"]', // pre-v2 cta below WP content
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Get matched with a lender',
          position: 'bottom',
          location: 'PREV2'
        })
      }
    },
    {
      selector: '#after-pre-back',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: 'Back',
          text: 'Back',
          position: 'top',
          location: 'rate table'
        })
        window.history.pushState({}, document.title, window.location.pathname)

        //reloading on back is temp fix which is why left in code below it
        window.location.reload()
        window.preActive = true
        window.hasLoaded = false
        removeClass(preElement, '+display-none')
        addClass(afterPreElement, '+display-none')
      }
    },
  ]

  window.preActive = true
  cohesion('preamp:decisionsReceived', function (decision) {

    // If the Remove PRE preamp asset is active remove the PRE
    if (decision.placements.find(placement => placement.assetName === "BR-Mortgage-Remove-PRE")) {
      addClass(preElement, '+display-none')
      removeClass(afterPreElement, '+display-none')
      document.querySelectorAll('.pre').forEach(function(el) {
        addClass(el, '+display-none')
      })
      document.querySelectorAll('.non-pre').forEach(function(el) {
        removeClass(el, '+display-none')
      })
      loadMRTCode()
      var checkApp = setInterval(function () {
        if (typeof(window.setFlag) != 'undefined') {
          window.setFlag('hideBrSelectText', false)
          clearInterval(checkApp)
        }
      }, 100);
      window.preActive = false
    }
  });

  /* Attach event listeners */
  eventList.forEach(function(event) {
    var elements = document.querySelectorAll(event.selector)
    elements.forEach((element) => {
      switch (event.type) {
        case 'view': {
          event.listener = function() {
            // do not send PRE view tracking events if PRE is hidden by preamp asset
            if (elementInView(element) && window.preActive) {
              event.handler(element)
              // console.log(event.selector + ' is in viewport')
              // event should only fire once
              window.removeEventListener('scroll', event.listener)
            }
          }
          window.addEventListener('scroll', event.listener)
          event.listener()
          break
        }
        case 'keydown': {
          element.addEventListener('keydown', function(keyDownEvent) {
            if (event.timer) {
              window.clearTimeout(event.timer)
            }
            event.timer = window.setTimeout(function() {
              event.handler(keyDownEvent)
              delete event.timer
            }, 2000)
          })
          break
        }
        default: {
          element.addEventListener(event.type, event.handler)
          break
        }
      }
    })
  })

  /* Helper functions */

  function getElementType(eventTarget) {
    var nodeName = eventTarget.nodeName.toLowerCase()
    if (nodeName === 'a') {
      return eventTarget.className.indexOf('button') === -1 ? 'link' : 'button'
    }
    return nodeName
  }

  function elementInView(el) {
    var bounding = el.getBoundingClientRect()
    var display = getComputedStyle(el).getPropertyValue('display')
    return display !== 'none' && bounding.top >= 0 && bounding.bottom <= window.innerHeight
  }

  function addClass(el, classNameToAdd) {
    el.className += ' ' + classNameToAdd;
  }

  function removeClass(el, classNameToRemove){
   var elClass = ' ' + el.className + ' ';
   while(elClass.indexOf(' ' + classNameToRemove + ' ') !== -1){
       elClass = elClass.replace(' ' + classNameToRemove + ' ', '');
   }
   el.className = elClass;
  }

  window.hasLoaded = false
  function loadMRTCode() {
    if (!window.hasLoaded) {
      window.scrollTo(0, 0);
      var urls = window.mrtUrls.split(",");
      var rateTableApp = document.getElementById("mortgage-rate-table-app");

      Promise.all(
        urls.map(function (url) {
          return loadScript(url, rateTableApp);
        })
      );
      window.hasLoaded = true
    }
  }

  function rateCardClickHandler(elementId) {
    addClass(preElement, '+display-none')
    removeClass(afterPreElement, '+display-none')
    var rateCard = document.getElementById(elementId).textContent.split(" ");
    var term = rateCard[0].replace('-year', 'yr')
    if (term.includes('/')) term = term.replace('/', '-') + 'arm';

    if(rateCard[2] === 'Refinance') {
      window.initialDimensions.mortgageType = "Refinance";
      window.initialDimensions.refinance.loanTerms = [term];
    } else {
      window.initialDimensions.mortgageType = "Purchase";
      window.initialDimensions.purchase.loanTerms = [term];
    }
    let queryParams = new URLSearchParams(window.location.search)
    queryParams.set('mortgageType', window.initialDimensions.mortgageType)
    history.replaceState(null, null, '?' + queryParams.toString())
    window.preActive = false
    loadMRTCode()
  }

  function selectLoanType(type) {
    window.initialDimensions.mortgageType = type
    let queryParams = new URLSearchParams(window.location.search)
    queryParams.set('mortgageType', type)
    history.replaceState(null, null, '?' + queryParams.toString())
    window.preActive = false
    loadMRTCode()
    addClass(preElement, '+display-none')
    removeClass(afterPreElement, '+display-none')
  }

  /* All handlers */

  function zipcodeInputted(event) {
    tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId: correlationId,
      formContext: {
        formId: correlationId,
        formName: 'PRE',
        formType: 'PRE'
      },
      userInputField: {
        fieldLabel: 'zip code',
        fieldName: 'zip code',
        fieldType: 'zip code',
        fieldValue: event.target.value
      }
    })

  }

  function loanTypeInputted(event, params = {}) {
    tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId: correlationId,
      formContext: {
        formId: correlationId,
        formName: params.formName || 'PRE',
        formType: params.formType || 'PRE'
      },
      userInputField: {
        fieldLabel: 'loan type',
        fieldName: 'loan type',
        fieldType: 'loan type',
        fieldValue: event.target.value
      }
    })
  }

  function universalClick(target, params) {
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      webElement: {
        elementType: params.elementType || getElementType(target),
        htmlId: target.id,
        location: params.location || 'PRE',
        name: params.name,
        position: params.position,
        text: params.text || target.textContent
      }
    })
  }

  function universalView(target, params) {
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      webElement: {
        elementType: params.elementType,
        htmlId: target.id,
        location: params.location || 'PRE',
        name: params.name,
        position: params.position,
        text: params.text || target.textContent
      }
    })
  }

  /* end of handlers */
})()
